import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "m8 40 2.985-11.285A7.68 7.68 0 0 1 18.409 23H21.5M40 40l-.525-2.125-2.954-9.774A7.18 7.18 0 0 0 29.65 23H26.5"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#F69100",
  d: "M24 13.5V24m0 14.5V31m-10.5 2.5c.815-2.173 3.842-3.165 6.438-4.5M24 24c0 2.513-1.878 3.877-4.062 5M24 24v7m0-7c0 2.513 1.878 3.877 4.062 5M18 33c0-1.2 1.292-3.167 1.938-4M24 31c.5.667 2.3 2 3.5 2M24 31c.667 1 2 4.2 2 5m8.5-2.5c-.815-2.173-3.842-3.165-6.438-4.5m0 0c.646.833 1.938 2.8 1.938 4M21 19.326a7 7 0 1 1 6 0"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "24",
  cy: "12",
  r: "1.5",
  stroke: "#F69100"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }